// src/pages/Home.js
import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import {
  Container,
  Grid,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
  Typography,
  Box
} from "@mui/material";


function Home() {
  const navigate = useNavigate();

  const modules = [
    {
      title: "Calculadora de Materiales",
      subtitle: "Cálculo de insumos",
      path: "/calculadora-materiales",
      image: "/images/modulo1.jpg",
      disabled: false
    },
    {
      title: "Estimador de Costos",
      subtitle: "Armado de presupuestos",
      path: "/presupuestador-obras",
      image: "/images/modulo2.jpg",
      disabled: false
    },
    {
      title: "Histórico de Precios",
      subtitle: "Registros y tendencias",
      path: "/historico-precios",
      image: "/images/modulo3.jpg",
      disabled: false
    },
    {
      title: "Hormigón Armado",
      subtitle: "Próximamente",
      path: "/historico-precios",
      image: "/images/modulo4.jpg",
      disabled: true
    }
  ];

  const handleCardClick = (mod) => {
    if (mod.disabled) {
      alert("Este módulo estará disponible próximamente.");
    } else {
      navigate(mod.path);
    }
  };

   // JSON-LD para structured data (ejemplo sencillo)
   const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "CALCU OBRA APP",
    "url": "https://calcuobra.com/",
    "applicationCategory": "BusinessApplication",
    "description": "Herramienta para calcular materiales, estimar costos y ver históricos de precios en la construcción en la Argentina.",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "ARS"
    }
  };

  return (
    <>
    <Helmet>
  <script type="application/ld+json">
    {JSON.stringify(jsonLdData)}
  </script>
</Helmet>



    <Container sx={{ mt: 3, mb: 3 }}>
      <Typography
        variant="h1"
        gutterBottom
        sx={{
          fontFamily: "'Bebas Neue', sans-serif",
          textAlign: "center",
          fontSize: { xs: "2rem", md: "3rem" }
        }}
      >
        Bienvenido a CALCU OBRA
      </Typography>
      <Typography
        variant="h2"
        gutterBottom
        sx={{
          fontFamily: "'Bebas Neue', sans-serif",
          textAlign: "center",
          fontSize: { xs: "1rem", md: "2rem" }
        }}
      >
        tu app para calcular proyectos
        </Typography>
        <div></div>
      <Typography 
        variant="body1" 
        sx={{
          mb: 4,
          textAlign: "center",
          fontFamily: "'Bebas Neue', sans-serif",
          fontSize: { xs: "0.8rem", md: "1.2rem" }
        }}
      >
        Seleccione un módulo para comenzar
      </Typography>
      <div></div>
      <Grid container spacing={2}>
        {modules.map((mod, idx) => (
          <Grid item xs={12} sm={6} md={3} key={idx}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                filter: mod.disabled ? "grayscale(100%)" : "none",
                cursor: mod.disabled ? "not-allowed" : "pointer",
                transition: "transform 0.3s",
                "&:hover": {
                  transform: mod.disabled ? "none" : "scale(1.05)"
                }
              }}
            >
              <CardActionArea
                onClick={() => handleCardClick(mod)}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "stretch"
                }}
              >
                {/* Contenedor para forzar la imagen cuadrada */}
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    aspectRatio: "1 / 1"
                  }}
                >
                  <CardMedia
                    component="img"
                    image={mod.image}
                    alt={mod.title}
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center"
                    }}
                  />
                </Box>
                <CardContent sx={{ textAlign: "center", flexGrow: 1 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontFamily: "'Bebas Neue', sans-serif",
                      fontSize: { xs: "1.2rem", md: "1.8rem" }
                    }}
                  >
                    {mod.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "'Bebas Neue', sans-serif",
                      fontSize: { xs: "1rem", md: "1.2rem" }
                    }}
                  >
                    {mod.subtitle}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          
        ))}
      </Grid>
      <div>  </div>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          fontFamily: "'Bebas Neue', sans-serif",
          textAlign: "center",
          fontSize: { xs: "1rem", md: "1.5rem" }
        }}
      >
        estimar una obra en Argentina, nunca fue tan fácil hasta ahora
      </Typography>
      <div>  </div>
    </Container>
    </>
  );
}

export default Home;
